<template>
  <span>
    Wir, die <strong>LumaBIT GmbH</strong>, sind ein erfahrenes
    IT-Dienstleistungsunternehmen mit
    <strong>Hauptsitz in Oberkirch</strong> und einem weiteren
    <strong> Standort in Nürnberg</strong>. Stets auf der Suche nach der
    nächsten Welle, die eine noch größere Herausforderung darstellt, genießen
    wir unseren Beruf als <strong>IT-Berater</strong> und bringen diese Freude
    auch mit zu unseren Kunden. <br /><br />
  </span>
</template>
